import type { InjectionKey, Ref } from 'vue'
import type { validateInput } from '../../composables/inputValidation'

export type ValidationHandler = (options?: { focusOnError: Ref<boolean> }) => ReturnType<typeof validateInput>

export const REGISTER_VALIDATION_HANDLER = Symbol() as InjectionKey<
  (h: { id: Symbol; validate: ValidationHandler; errorMessages: Ref<string[]> }) => void
>

export const UNREGISTER_VALIDATION_HANDLER = Symbol() as InjectionKey<(id: Symbol) => void>
